import React from 'react';
import PropTypes from 'prop-types';

import './DropDownMenu.scss'

export function DropDownMenu({
    children = null,
    className = '',
    menuRef,
    role = 'menu',
}) {
    const classes = ['dropdown-list', className].filter(Boolean).join(' ');

    return(
        <div className={classes} ref={menuRef} role={role}>
            {children}
        </div>
    )
}

DropDownMenu.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    menuRef: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({ current: PropTypes.instanceOf(Element) })
    ]),
    role: PropTypes.string,
};
